import React, { useState } from 'react'
import { putData } from '../../../../services/library';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Typography } from '@mui/material';
import Notify from '../../../Notify';

function MarcarActivoTipoCliente(props) {
const [datosTipo, setDatosTipo] = useState(props.tipo);
  const [disBtn, setDisBtn] = useState(false);

  const handleClose = () => {
    props.setOpen(false)
  };

  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  async function marcarActivo(e) {
    setDisBtn(true);
    putData(
      e,
      "/tipoclienteenvasado/" + datosTipo.id,
      {
        activo: 1,
      },
      setNotificacion
    );
  }
  return (
    <div>
      <Dialog open={props.open} onClose={handleClose}>
        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => {
              props.actualizar();
              props.setOpen(false);
              setNotificacion({open:false})
            }}
            severity={notificacion.severity}
          />
        ) : null}
        <form onSubmit={marcarActivo}>
          <Box backgroundColor={"#1F618D"}>
            <DialogTitle>
              <Typography color="#ffffff" fontSize={20}>
                Alta de Tipo de Cliente: {datosTipo.id}
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent>
            <DialogContentText textAlign={"center"}>
            ¿Seguro que quiere dar de Alta el tipo nuevamente?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack spacing={45} direction="row">
              <Button
                color="error"
                disabled={disBtn}
                variant="contained"
                onClick={handleClose}
              >
                Cancelar
              </Button>
              <Button
                color="success"
                type="submit"
                variant="contained"
              >
                Confirmar
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}

export default MarcarActivoTipoCliente